const getVersion = (): string => {
  return process.env.NODE_ENV === 'test' ? '0.0.0' : VERSION
}

export const EnvironmentUtils = {
  getVersion,
}
